import { render, staticRenderFns } from "./AddressRequirementsAgreementDialog.vue?vue&type=template&id=1affcedf&scoped=true&lang=pug&"
import script from "./AddressRequirementsAgreementDialog.vue?vue&type=script&lang=ts&"
export * from "./AddressRequirementsAgreementDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1affcedf",
  null
  
)

export default component.exports